import { render, staticRenderFns } from "./monitorBag.vue?vue&type=template&id=5c71289e&scoped=true&"
import script from "./monitorBag.vue?vue&type=script&lang=js&"
export * from "./monitorBag.vue?vue&type=script&lang=js&"
import style0 from "./monitorBag.vue?vue&type=style&index=0&id=5c71289e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71289e",
  null
  
)

export default component.exports